module.exports = __webpack_public_path__ + "media/images/marketing/blog3-1f0c331a193174ddf6a53de0b37b89253d42f9e0cdc22a242e75f1e1f2a5091e.jpg";